// Mirrors the server-side rules on Onboard::CandidateSubmissionAsset
// (CANDIDATE_UPLOAD_FILE_NAME_PATTERN and `validates_attachment_size less_than: 25.megabytes`),
// so a file the picker accepts is never rejected after upload.
export const UPLOAD_ACCEPT = '.pdf,.doc,.docx,.jpg,.jpeg,.png';
export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
export const UPLOAD_LIMITS_HINT = 'Maximum size per file: 25MB';
export const UPLOAD_FORMATS_HINT = 'Please only use these file formats: PDF, DOCX, DOC, JPG, PNG';

const ALLOWED_FILE_NAME = /\.(pdf|docx?|jpe?g|png)$/i;
const HEIC_FILE_NAME = /\.(heic|heif)$/i;

export const uploadRejection = (file: File): string | null => {
  if (HEIC_FILE_NAME.test(file.name)) {
    return `"${file.name}" is a HEIC photo, which can't be uploaded. Please convert it to JPG or PNG, or choose it from your photo library instead of Files.`;
  }
  if (!ALLOWED_FILE_NAME.test(file.name)) {
    return `"${file.name}" isn't a supported file type. Please use PDF, DOCX, DOC, JPG or PNG.`;
  }
  if (file.size >= MAX_UPLOAD_BYTES) {
    return `"${file.name}" is too large. Each file must be smaller than 25MB.`;
  }
  return null;
};

export const partitionUploads = (files: File[]): { accepted: File[]; rejections: string[] } =>
  files.reduce<{ accepted: File[]; rejections: string[] }>(
    (result, file) => {
      const rejection = uploadRejection(file);
      if (rejection) result.rejections.push(rejection);
      else result.accepted.push(file);
      return result;
    },
    { accepted: [], rejections: [] }
  );
